import React from 'react';
import Questions from './components/Questions';
import Quote from './components/Quote';
import MessageModal from './components/MessageModal';
import { Container } from 'react-bootstrap'
import TagManager from 'react-gtm-module'
import './scss/App.scss';

let API_PROTOCOL = "https"
let API_ENDPOINT = "wwufyss5m4.execute-api.ap-southeast-2.amazonaws.com" // https://wwufyss5m4.execute-api.ap-southeast-2.amazonaws.com/Prod
let API_STAGE = "/Prod"
const API_REGION = "ap-southeast-2"

if (process.env.REACT_APP_ENV_NAME == 'local') {
  console.log('Connecting to local backend')
  API_PROTOCOL = "http"
  API_ENDPOINT = "127.0.0.1:1337"
  API_STAGE = ""
}

async function apiFetch({ endpoint, body }) {
  var options = {
    method: "POST",
    region: API_REGION,
    host: API_ENDPOINT,
    path: `/Prod/${endpoint}`,
    url:`${API_PROTOCOL}://${API_ENDPOINT}${API_STAGE}/${endpoint}`,
    body: JSON.stringify(body)
  }
  const res = await fetch(options.url, {
    method: "POST",
    //headers:request.headers,
    body: JSON.stringify(body)
  })
  if (!res || !res.ok) {
      console.log("error", res)
  } else {
      console.log("Sent", res)
  }
  return res
}

function setThemeProperty(name, color) {
  document.documentElement.style.setProperty(name, color)
}

export default class App extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      results: null,
      computed: null,
      query: null,
      calculateBusy: false,
      emailBusy: false,
      disabled: false, // i.e. any busy?
      contactDetails: null,
      message: null,
    }

    this.initTheme()
    this.initGoogleTagManager()
  }

  initGoogleTagManager = () => {
    const hostname = window.location.hostname
    const isLocal = hostname.includes('localhost')

    const tagMangerArgs = {
      positivesalarypackaging: {
        gtmId: 'GTM-P93JC2X'
      },

      aant: {
        gtmId: 'GTM-ML3W6NK'
      }
    }

    let args = null
    if (isLocal || hostname.includes('aant')) {
      args = tagMangerArgs.aant
    }

    //qld.positivesp
    if (
      hostname.includes("positivesalarypackaging") ||
      hostname.includes("positivesp") ||
      hostname.includes("kooya")
    ) {
      args = tagMangerArgs.positivesalarypackaging;
    }

    if (args) {
      TagManager.initialize(args)
    }
  }

  initTheme = () => {
    const hostname = window.location.hostname
    const isLocal = hostname.includes('localhost')

    const themes = {
      positivesalarypackaging: {
        '--calc-bg-color': 'white',
        '--calc-primary-color': '#00437c',
        '--calc-secondary-color': '#5cb852',
        '--calc-font-family': 'Work Sans'
      },

      aant: {
        '--calc-bg-color': 'white',
        '--calc-primary-color': '#2E486A',
        '--calc-secondary-color': '#ED1C24',
        '--calc-font-family': 'Inter'
      }
    }

    let theme = {}
    console.log(`[initTheme] hostname: ${hostname}`)
    if (isLocal || hostname.includes('aant')) {
      theme = themes.aant
    }

    //qld.positivesp
    if (
      hostname.includes("positivesalarypackaging") ||
      hostname.includes("positivesp") ||
      hostname.includes("kooya")
    ) {
      theme = themes.positivesalarypackaging;
    }

    // apply theme
    for (const [key, value] of Object.entries(theme)) {
      setThemeProperty(key, value)
    }
  }

  pushResultsToApiEndpoint = async ({ endpoint, fleet_pricing_enquiry }) => {
    try {
      const { contactDetails, query, computed, results } = this.state;
      const hostname = window.location.hostname;
      const values = { ...contactDetails, ...query, ...computed, ...results, fleet_pricing_enquiry, hostname };
      console.log("pushResultsToApiEndpoint values:", values);
      const r = await apiFetch({ endpoint, body: values });
      const json = await r.json();
      return json;
    }
    catch (err) {
      console.error(err);
    }
  }

  pushResultsToSalesforce = async (fleet_pricing_enquiry = false) => {
    try {
      const r = await this.pushResultsToApiEndpoint({ endpoint: 'pushResultsToSalesforce', fleet_pricing_enquiry });
      return r
    } catch (err) {
      console.error("error", err);
      // Handle error here
      return { success: false, error: err.message };
    }
  };

  pushResultsToSpreadsheet = async (fleet_pricing_enquiry = false) => {
    return await this.pushResultsToApiEndpoint({ endpoint: 'pushResultsToSpreadsheet', fleet_pricing_enquiry });
  }

  pushResultsToEmail = async (fleet_pricing_enquiry = false) => {
    return await this.pushResultsToApiEndpoint({ endpoint: 'sendEmail', fleet_pricing_enquiry });
  }

  onShowQuote = async (query, contactDetails) => {
    console.log("onShowQuote:", query, contactDetails);
    this.setState({ calculateBusy: true, disabled: true, contactDetails });
    const leasePeriod = query.lease_term * 12; //convert years to months

    // map car size to a variant id + other things that are car specific (phev fuel_cpl)
    const carVariantMap = {
      'small': {
        variant_id: '107264', // Toyota Yaris

        phev: {
          variant_id: '156770', // Ford Escape

          fuel_cpl: 2.5,
          qt_quote_maintenance_service: 0.015,
          qt_quote_tyres: 0.03,
          //qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 700,
          qt_quote_insurance: 1100,

          
        },
        electric: {
          variant_id: '158290', // BYD Atto 3

          fuel_cpl: 0.3,
          qt_quote_maintenance_service: 0.01,
          qt_quote_tyres: 0.03,
          qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 700,
          qt_quote_insurance: 1100,
        }
      },
      'medium': {
        variant_id: '113209', // Toyota Camry

        phev: {
          variant_id: '156649', // Eclipse Cross

          fuel_cpl: 3.0,
          qt_quote_maintenance_service: 0.02,
          qt_quote_tyres: 0.04,
          //qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 750,
          qt_quote_insurance: 1200,
        },
        electric: {
          variant_id: '156834', // Tesla 3

          fuel_cpl: 0.3,
          qt_quote_maintenance_service: 0.015,
          qt_quote_tyres: 0.04,
          qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 750,
          qt_quote_insurance: 1200,
        }
      },
      'large': {
        variant_id: '104441', // Toyota Kluger

        phev: {
          variant_id: '158366', // Outlander PHEV

          fuel_cpl: 4.0,
          qt_quote_maintenance_service: 0.025,
          qt_quote_tyres: 0.05,
          //qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 800,
          qt_quote_insurance: 1400,
        },
        electric: {
          variant_id: '156835', // Tesla 3 LR

          fuel_cpl: 0.3,
          qt_quote_maintenance_service: 0.02,
          qt_quote_tyres: 0.05,
          qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 800,
          qt_quote_insurance: 1400,
        }
      },
      '4wd': {
        variant_id: '114151', // Ford Ranger

        phev: {
          variant_id: '157899', // Sorento PHEV

          fuel_cpl: 5.0,
          qt_quote_maintenance_service: 0.03,
          qt_quote_tyres: 0.06,
          //qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 850,
          qt_quote_insurance: 1600,
        },
        electric: {
          variant_id: '157198', // Tesla Model Y

          fuel_cpl: 0.3,
          qt_quote_maintenance_service: 0.025,
          qt_quote_tyres: 0.06,
          qt_quote_fuel: 0.042,
          qt_quote_reg_ctp: 850,
          qt_quote_insurance: 1600,
        }
      }
    }
    const carVariant = carVariantMap[query.car_variant]
    let variant_id = carVariant.variant_id
    const distance = Number(query.distance)

    // electric and phev have different variant_ids
    if (query.fuel_type == 'electric' || query.fuel_type == 'phev') {
      variant_id = carVariant[query.fuel_type].variant_id
    }

    // compute the fbt_benefit_type based on the fuel type
    //
    // If petrol or deisel, fbt_benefit_type = statutory
    // If electric of phev (hybrid) AND vehicle cost (budget) is equal to or less than 92000 then fbt_benefit_type = excmpt
    // else if over the 92000, then fbt_benefit_type = statutory
    const FBT_VEHICLE_COST_LIMIT = 92000
    let fbt_benefit_type = 'statutory'
    if (query.fuel_type == 'electric' || query.fuel_type == 'phev') {
      if (query.budget <= FBT_VEHICLE_COST_LIMIT) {
        fbt_benefit_type = 'exempt'
      }
    }

    let url = ``
          + `&variant_id=${variant_id}`
          + `&approximate_price=${query.budget}`
          + `&state_registered=SA`
          + `&annual_kilometres=${query.distance}`
          + `&lease_period=${leasePeriod}`
          + `&annual_salary=${query.salary}`
          + `&pay_cycle_code=${query.pay_cycle?.toLowerCase()}`
          + `&fbt_benefit_type=${fbt_benefit_type}`
/*
    // apply elecric specific settings
    if (query.fuel_type == 'electric') {
      url +=`&qt_quote_maintenance_service=${carVariant.electric.qt_quote_maintenance_service * distance}`
          + `&qt_quote_tyres=${carVariant.electric.qt_quote_tyres * distance}`
          + `&qt_quote_fuel=${carVariant.electric.qt_quote_fuel * distance}`
          + `&qt_quote_reg_ctp=${carVariant.electric.qt_quote_reg_ctp}`
          + `&qt_quote_insurance=${carVariant.electric.qt_quote_insurance}`
          + `&fuel_cpl=${carVariant.electric.fuel_cpl}`
    }

    // apply phev specific settings
    if (query.fuel_type == 'phev') {
      url +=`&qt_quote_maintenance_service=${carVariant.phev.qt_quote_maintenance_service * distance}`
          + `&qt_quote_tyres=${carVariant.phev.qt_quote_tyres * distance}`
          //+ `&qt_quote_fuel=${carVariant.phev.qt_quote_fuel * distance}`
          + `&qt_quote_reg_ctp=${carVariant.phev.qt_quote_reg_ctp}`
          + `&qt_quote_insurance=${carVariant.phev.qt_quote_insurance}`
          + `&fuel_cpl=${carVariant.phev.fuel_cpl}`
    }
    */
    console.debug(url)

    try {
      const r = await apiFetch({ endpoint: 'getQuote', body: { queryString: url } });
      const json = await r.json();
      const quote = json.data;

      const running_costs_per_pay_cycle_gross = Number(quote.total_lease_per_pay_cycle_gross) - Number(quote.fin_per_pay_cycle_gross); //-Number(quote.mfee_per_pay_cycle_gross);
      const total_package_cost_per_pay_cycle = Number(quote.after_tax_effect_per_pay_cycle);
      const cost_of_car_per_pay_cycle = total_package_cost_per_pay_cycle - running_costs_per_pay_cycle_gross;
      const tax_savings = ((Number(quote.total_lease_per_pay_cycle_gross) - Number(quote.after_tax_effect_per_pay_cycle) + Number(quote.gst_per_pay_cycle_net)) * Number(quote.total_contract_pay_cycles)) + Number(quote.claimable_gst);

      const results = {
        total_package_cost_per_pay_cycle, // Total Package Cost
        running_costs_per_pay_cycle_gross, // Running Expenses Included
        cost_of_car_per_pay_cycle,
        tax_savings,
      };

      // not the query the user performed, and not the results, but the intermediately computed values
      const computed = {
        variant_id,
      }

      this.setState({ calculateBusy: false, disabled: false, query, computed, results }, () => {
        this.pushResults(false)
      });
    } catch (err) {
      console.error(err);
      this.setState({ calculateBusy: false, disabled: false, error: err });
    }
  }

  pushResults = async (fleet_pricing_enquiry) => {
    const hostname = window.location.hostname
    const isLocal = hostname.includes('localhost')

    console.log(`[pushResults] hostname: ${hostname}`);

    // Adam wants to keep this even though we are now pushing to salesforce, just as a backup measure (https://app.clickup.com/t/86cx38g4a)
    if (isLocal || hostname.includes("aant")) {
      var responseSendEmail = await this.pushResultsToEmail(fleet_pricing_enquiry);
      console.log("SendEmail Response...", responseSendEmail);
    }

    //Valid hostnames for pushing results to salesforce
    const validHostnames = [
      "positivesalarypackaging",
      "positivesp",
      "kooya",
      "aant"
    ];

    if (
      isLocal ||
      validHostnames.some((substring) => hostname.includes(substring))
    ) {
      var responseSalesforce = await this.pushResultsToSalesforce(
        fleet_pricing_enquiry
      );
      console.log("Salesforce Response...", responseSalesforce);
      //If failed to pushToSalesForce
    }

    //always send results to Google Sheets
    var googlePushResponse = await this.pushResultsToSpreadsheet(fleet_pricing_enquiry);
    console.log("Google Push Response...", googlePushResponse);
  }

  onFleetPricing = async () => {
    await this.pushResults(true)
   
    // fleetPricingRedirect should let an outside user inject the redirect url we should end up at
    window.location.href = window.fleetPricingRedirect || '/novated-calculator-thankyou/';
  }


  render() {
    const { results, error } = this.state;

    return (
      <Container className="App">
        <Questions onShowQuote={this.onShowQuote} {...this.state}/>
        {results && <Quote onFleetPricing={this.onFleetPricing} {...this.state}/>}
        <MessageModal show={!!this.state.message} onHide={() => this.setState({ message: null })} {...this.state.message} />
        <MessageModal show={error && !!error.message} onHide={() => this.setState({ error: null })} title="An error occured" text={error && error.message} />
      </Container>
    );
  }
}